import styled from '@emotion/styled';
import HypotheekbondLogoSvg from 'images/shared/hypotheekbond-abc.svg';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  
  svg {
    display: block;
    height: 24px;
  }
`;

export const HypotheekbondLogo = () => (
  <Wrapper>
    <HypotheekbondLogoSvg />
  </Wrapper>
);

export default HypotheekbondLogo;
